const CreateOrder = () => import(/* webpackChunkName: "createOrder" */ '@/components/createOrder/index')
export default {
    name: 'createOrder',
    path: 'createOrder',
    redirect: '/createOrder/index',
    meta: {label: 'createOrder'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Create', auth: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]},
            component: CreateOrder,
            props: true
        }
    ]
}
